import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { Moon, Sun } from 'lucide-react';
import { useColorMode } from '../../context/ColorModeContext';

const Navbar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const { mode, toggleMode } = useColorMode();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleNavItemClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="logo" onClick={handleNavItemClick}>
        ZapTick <span>AI</span>
      </Link>
      <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
        <Link to="/" onClick={handleNavItemClick}>Home</Link>
        <Link to="/features" onClick={handleNavItemClick}>Features</Link>
        <Link to="/about" onClick={handleNavItemClick}>About</Link>
        {/* <button
          className="cta-matiyari"
          onClick={() => {
            handleNavItemClick();
            navigate('/matiyari');
          }}
        >
          MATIYARI
        </button> */}
        <button
          type="button"
          className="theme-toggle-btn"
          onClick={toggleMode}
          aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          title={mode === 'dark' ? 'Light mode' : 'Dark mode'}
        >
          {mode === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        <button
          className="cta-secondary"
          onClick={() => {
            handleNavItemClick();
            navigate('/partners');
          }}
        >
          Partners
        </button>
        <button
          className="cta"
          onClick={() => {
            handleNavItemClick();
            navigate('/login');
          }}
        >
          Get Started
        </button>
      </div>
      <div className={`burger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
        <span className="burger-line"></span>
        <span className="burger-line"></span>
        <span className="burger-line"></span>
      </div>
    </nav>
  );
};

export default Navbar;
